import scheduleEn from './scheduleEn';
import scheduleEs from './scheduleEs';
import schedulePt from './schedulePt';

const fixtures = {
  scheduleEn,
  scheduleEs,
  schedulePt,
};

export default fixtures;



/** WEBPACK FOOTER **
 ** ./src/fixtures/index.js
 **/